// @flow

import type {
  IDNumber,
  TaskInstance,
  TaskInstanceStatus,
  UpdateSubtaskStatusAction,
  UpdateTaskInstanceSuccessAction,
  UpdateSubtaskStatusFailureAction,
  CompleteTaskInstanceAction,
  ReopenTaskInstanceAction
} from '../common/typings';

export const UPDATE_SUBTASK_STATUS = 'UPDATE_SUBTASK_STATUS';
export const UPDATE_SUBTASK_STATUS_FAILURE = 'UPDATE_SUBTASK_STATUS_FAILURE';
export const UPDATE_TASK_INSTANCE_SUCCESS = 'UPDATE_TASK_INSTANCE_SUCCESS';
export const COMPLETE_TASK_INSTANCE = 'COMPLETE_TASK_INSTANCE';
export const REOPEN_TASK_INSTANCE = 'REOPEN_TASK_INSTANCE';

export function updateSubtaskStatus(
  taskInstance: TaskInstance,
  subtaskId: IDNumber,
  status: TaskInstanceStatus
): UpdateSubtaskStatusAction {
  return {
    type: UPDATE_SUBTASK_STATUS,
    payload: {
      taskInstance,
      subtaskId,
      status
    }
  };
}

export function updateTaskInstanceSuccess(
  taskInstance: TaskInstance
): UpdateTaskInstanceSuccessAction {
  return {
    type: UPDATE_TASK_INSTANCE_SUCCESS,
    payload: {
      taskInstance
    }
  };
}

export function updateSubtaskStatusFailure(
  response: Object | boolean
): UpdateSubtaskStatusFailureAction {
  return {
    type: UPDATE_SUBTASK_STATUS_FAILURE,
    error: true,
    payload: {
      response
    }
  };
}

export function completeTaskInstance(taskInstance: TaskInstance): CompleteTaskInstanceAction {
  return {
    type: COMPLETE_TASK_INSTANCE,
    payload: {
      taskInstance
    }
  };
}

export function reopenTaskInstance(taskInstance: TaskInstance): ReopenTaskInstanceAction {
  return {
    type: REOPEN_TASK_INSTANCE,
    payload: {
      taskInstance
    }
  };
}
